export default {
  text: 'Zweryfikuj przez {{provider}}',
  text_generic: 'Zweryfikuj przez dostawcę płatności',
  error: 'Nie udało się otworzyć formularza {{provider}}. Spróbuj ponownie.',
  error_generic: 'Nie udało się otworzyć formularza dostawcy płatności. Spróbuj ponownie.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
